import * as productsActions from '@Actions/products';

import { put, retry, takeLatest } from 'redux-saga/effects';

import { AxiosResponse } from 'axios';
import { GetProductsResponse } from '@Types/products.types';
import { getSubscriptions } from '@Services/subscriptions';

function* getProductsSaga() {
	const { getProductsResolved, getProductsRejected } = productsActions;
	try {
		const response: AxiosResponse<GetProductsResponse> = yield retry(
			5,
			1500,
			getSubscriptions,
		);
		if (response.data.subscriptions) {
			yield put(getProductsResolved(response.data.subscriptions));
		} else {
			yield put(getProductsRejected());
		}
	} catch (e) {
		yield put(getProductsRejected());
	}
}

function* watchGetProducts() {
	yield takeLatest(productsActions.getProducts, getProductsSaga);
}

export default [watchGetProducts()];
